import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { NormAssignEdit, NormAddEdit } from './Pages';

export const NormAssignRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={NormAssignEdit} />
        <Route exact path={`${match.path}/addEdit`} component={NormAddEdit} />
    </Fragment>
)